
export const GET_TESTING_ACCOUNT = 'GET_TESTING_ACCOUNT';